import { useEffect, useRef } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import useCart from 'shared/hooks/use-cart';
import { cartDidViewCart } from 'utils/ecommerce-analytics';
import { tracker } from '..';
import { GTM_V2_FLAG } from '../constants/feature-flags';

/** Fires view_cart event when cart data is available. Fires once per cartId. */
export const useCartViewedMonitor = (): void => {
  const Cart = useCart();
  const flags = useFlags();
  const useV2 = !!flags[GTM_V2_FLAG];
  const firedForCartId = useRef<string | null>(null);

  const { checkoutToken: cartId, dispensary, cart } = Cart?.order ?? {};
  const { id: dispensaryId, name: dispensaryName } = dispensary ?? {};
  const subtotalValue = useV2 ? Cart?.costBreakdown?.total : Cart?.costBreakdown?.subtotal;
  const cartLength = cart?.length ?? 0;

  useEffect(() => {
    if (!cartId || !cart) {
      return;
    }

    if (useV2 && (cartLength === 0 || subtotalValue == null)) {
      return;
    }

    tracker.setContext({
      activeCart: {
        ...cart,
        subtotal: subtotalValue,
        checkoutToken: cartId,
      },
    });

    if (firedForCartId.current === cartId) {
      return;
    }
    firedForCartId.current = cartId;

    tracker.cartViewed({
      cartId,
      products: cart,
      dispensaryId,
      dispensaryName,
    });

    cartDidViewCart(cart, useV2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartId, dispensaryId, dispensaryName, subtotalValue, cartLength]);
};
